import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import { normalizeChannel } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.PUBLISH');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS } = ACTIONS;


function checkPublishStatus(taskId) {
  return new Promise(function (resolve) {
    vodAdapter.list.checkPublish(taskId)
      .then(
        resolve,

        function () {
          setTimeout(() => {
            checkPublishStatus(taskId).then(resolve);
          }, 2000);
        }
      );
  });
}


export default function publish(id, shouldCheckPublish = false) {
  if (!id) {
    return;
  }

  const data = normalizeChannel({ id, hasChangesToPublish: false });

  return function (dispatch) {
    dispatch(START({ id }, { data }));

    return vodAdapter.list.publish(id)
      .then(shouldCheckPublish ? checkPublishStatus : _.noop)
      .then(function () {
        dispatch(SUCCESS({}, { data }));
      });
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/channel/publish.js